module.exports = __webpack_public_path__ + "img/icon-enterprise.c8601cbd.svg";